(ns ycweb.app.website
  (:require
   [rum.core :as rum]

   [ycweb.util.comms :as comms]
   [ycweb.app.website.tracking :as tracking]

   [ycweb.components.state :as state]
   [ycweb.components.flow :as flow]
   [ycweb.components.grid :as grid]
   [ycweb.components.appcommon :as appcommon]
   [ycweb.components.common :as cmn]

    ;; These are required for their multimethods, don't worry about them not being referenced.
   [ycweb.app.common :as yac]
   [ycweb.app.pos.dev]
   [ycweb.app.website.cards]
   [ycweb.app.website.demo.demo]
   [ycweb.app.website.myaccount.myaccount]
   [ycweb.app.website.cart.cart]
   [ycweb.app.website.help.help]
   [ycweb.app.website.header.header]
   [ycweb.app.website.school.school]
   [ycweb.app.website.donation.donation]
   [ycweb.app.website.dlp.dlp]
   [ycweb.app.website.dlp.competition-success]
   [ycweb.app.website.registry.registry]
   [ycweb.app.website.search.results]
   [ycweb.app.website.search.instantsearch]
   [ycweb.app.website.stores.store-directory]
   [ycweb.app.website.unsubscribe.unsubscribe]
   [ycweb.app.website.devtools.devtools]
   [ycweb.app.website.mrprice.mrprice]
   [ycweb.app.website.voucher.voucher]
   [ycweb.app.website.auth.login]
   [ycweb.app.website.auth.register]
   [ycweb.app.website.auth.forgotpassword]
   [ycweb.app.website.auth.confirm]
   [ycweb.app.website.auth.erasure]
   [ycweb.app.website.products.product]
   [ycweb.app.website.jobs.jobs]
   [ycweb.app.website.trade.trade]
   [ycweb.app.website.keepaside.keepaside]
   [ycweb.app.website.footer.footer]
   [ycweb.components.cards]
   [ycweb.components.svg-icons])

  (:require-macros
   [ycweb.util.core :as uv]))

(defn initial-state [started?]
  {:page {:screen :loading}
   :app {:started started? :version (uv/env :build-number "dev") :app "web"}
   :device {:screen (state/screen-size) :id (comms/deviceid)}})

(defonce app-atom
  (atom (initial-state false)))

(yac/init-sentry)

(enable-console-print!)

(println "Loading Website.")
(println "Build Number:" (uv/env :build-number "dev"))

(rum/defc loading < rum/static []
  [:div
   [:header
    [:h1 "Loading..."]]])

(defmethod flow/render-screen :loading [app-atom _]
  (loading))

;; Startup
(defmethod comms/receive :chsk/state [app-atom [old new]]
  (when (and (:open? new) (not (get-in @app-atom [:comms :started])))
    ;; In future we'll likely set up websockets as needed, and :web/start would likely have already been called
    #_(comms/send :web/start {})
    (swap! app-atom assoc-in [:comms :started] true)))

(defmethod comms/receive :web/start [app-atom {:keys [registry opts user cat-nav stats config features]}]
  #_(toaster/close-toast app-atom)
  (swap! app-atom
    #(->
       %
       (assoc
         :registry/order-id (:order-id registry)
         :opts opts
         :user user
         :cat-nav cat-nav
         :stats stats
         :config config
         :features features)))

  ;; TODO: We need to figure this out for the customer facing website.
  #_(presence/setup-presence-widget app-atom)

  (appcommon/start-complete! app-atom))

(defn ^:dev/after-load refresh []
  (rum/mount
    (appcommon/root app-atom)
    (.getElementById js/document "website-react-mount")))

(defmethod grid/action :state/reset [app-atom config _]
  (reset! app-atom
    (merge
      (initial-state true)
      config))
  (comms/send :web/start {})
  (refresh))

(defn current-keys-atom [current-atom]
  (rum/cursor current-atom :current-keys))

(defn key-tracker
  "This provides a keypress tracker
   to facilitate shortcuts under :current-keys of the app-atom"
  [current-atom]
  (let [keys-atom (current-keys-atom current-atom)]
    (reset! keys-atom #{})
    (.addEventListener js/document "keydown"
      (fn [e]
        (swap! keys-atom conj (.-key e))))

    (.addEventListener js/document "keyup"
      (fn [e]
        (swap! keys-atom disj (.-key e))))))

(defn pressed-keys [current-atom]
  @(current-keys-atom current-atom))

(defn modal-accessibility [current-atom]
  (let [modal-wrapper (.getElementById js/document "modal-wrapper")]
    (when (:open (:modal @app-atom))
      (when modal-wrapper (.focus modal-wrapper))
      (.add (.-classList (.-body js/document)) "body--no-scroll"))))

(defn modal-tabbing [current-atom]
  (.addEventListener js/document "keydown"
    (fn [e]
      (let [pressed (pressed-keys current-atom)
            active-tab (.-activeElement js/document)
            modal (.getElementById js/document "modal-wrapper")
            tab-element (.querySelectorAll modal "button, iframe, input, select, textarea, [href], [tabindex]")
            first-tab (first tab-element)
            last-tab (.getElementById js/document "last-tab")]
        (cond
          (and
            (contains? pressed "Shift")
            (contains? pressed "Tab"))
          (when
            (and
              last-tab
              (= active-tab first-tab))
            (.focus last-tab)
            (.preventDefault e))

          (contains? pressed "Tab")
          (when
            (and
              first-tab
              (= active-tab last-tab))
            (.focus first-tab)
            (.preventDefault e)))))))

(defn main []
  (let [pos (appcommon/entry-main "website-react-mount" app-atom refresh)]
    (key-tracker app-atom)
    (tracking/install-inspector!)
    (modal-accessibility app-atom)
    (modal-tabbing app-atom)

    (appcommon/bind-urlstate app-atom
      {:fragment? false :base-prefix "web." :screen-action? true})

    (rum/hydrate (appcommon/root app-atom) pos)

    ;; Server-rendered mounts skip the :web/start request, so finish startup
    ;; here instead — after hydrate, where the response would have landed.
    (when (appcommon/hydrated? app-atom)
      (appcommon/start-complete! app-atom))))


